import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { formatAndMaskSSN, formatDateFromServer } from 'src/utils/formater';
import Provider from 'src/models/provider';
import { ExternalData } from 'src/utils/customInterface';
const USStates: Array<ExternalData> = require('src/api/data/states.json');
import { formatAddress } from 'src/utils/formater';
import PopupConfirm from 'src/components/shared/PopupConfirm';
import { removeWorkflowContextData } from 'src/utils/workflow';
import { WorkflowContext } from '../../utils/constValues';

export interface StateFromProps {
    registrationId: string;
    loading: boolean;
    provider: Provider;
    submitting: boolean;
    submitted: boolean;
}

export interface DispatchFromProps {
    getProviderById: (id: string) => void;
    submitToVendor: (registrationId: string) => void;
    resetSubmitStatus: () => void;
}

export type OwnProps = RouteComponentProps<{}>;

type Props = StateFromProps & DispatchFromProps & OwnProps;

export interface State {
    hasError: boolean;
    showPopup: boolean;
    hideSSN: boolean;
}

class Summary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        window.document.title = 'Summary';
        this.state = this.state = this.getInitialState();
    }

    getInitialState = (): State => {
        return {
            hasError: false,
            showPopup: false,
            hideSSN: true
        };
    }

    componentDidMount() {
        const { registrationId } = this.props;
        if (registrationId != undefined) {
            this.props.getProviderById(registrationId);
        }
    }

    componentWillReceiveProps(nextProps: Props) {
        if (!this.props.submitted && nextProps.submitted) {
            this.setState({ showPopup: true });
            this.props.resetSubmitStatus();
        }
    }

    submitToVendor = (): void => {
        const { registrationId } = this.props;
        const { hasError } = this.state;
        if (!hasError && registrationId) {
            this.props.submitToVendor(registrationId);
        }
    }

    confirm = (): void => {
        this.setState({ showPopup: false });
        removeWorkflowContextData(WorkflowContext.WorkingRegistrationId);
        removeWorkflowContextData(WorkflowContext.PROVIDER_INFO_PAYMENT);
        removeWorkflowContextData(WorkflowContext.PROVIDER_INFORMATION_PAYMENT);
        removeWorkflowContextData(WorkflowContext.WorkFlowData);
        removeWorkflowContextData(WorkflowContext.ATTEMPT_COUNTER_STEP_ONE);
        removeWorkflowContextData(WorkflowContext.ATTEMPT_COUNTER_STEP_TWO);
        window.location.replace('https://www.acscripts.com');
    }

    upperCaseFirst = (str: string | undefined) => {
        if (str) {
            let lowerStr = str.toLowerCase();
            return lowerStr[0].toUpperCase() + lowerStr.slice(1);
        }
        return '';
    }

    showHideSSN = (): void => {
        const { hideSSN } = this.state;
        this.setState({
            hideSSN: !hideSSN
        });
    }

    render() {
        const { loading, submitting, provider } = this.props;
        const { showPopup, hideSSN } = this.state;

        return (
            <main>
                <div className="tab-content tabs-style">
                    <div className="tab-pane h-100 fade show active" id="" role="tabpanel">
                        <div className="flex-full">
                            <div className="fix-workspace flex-full">
                                <div className="tab-content wrapper-lv-4">
                                    <div className="tab-pane h-100 fade show active" role="tabpanel">
                                        <div className="row no-gutters pl-1 pr-1 h-100">
                                            <div className="col main-cont">
                                                <div className="flex-full card-sp">
                                                    <h5 className="card-title-sp">Provider Information</h5>
                                                    <div className="card-cont-sp flex-full">
                                                        <div className="fix-workspace">

                                                            <div className="autoscroll-1 border-cont">
                                                                {
                                                                    loading || submitting ?
                                                                        <div className="loading-center">
                                                                            <table className="table table-borderless">
                                                                                <tbody className="spinner-bg d-flex">
                                                                                    <tr className="text-center">
                                                                                        <td className="alert alert-info" role="alert">
                                                                                            <span className="alert-text"><span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />{submitting ? 'Submitting...' : 'Loading...'}</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        : typeof (provider) != undefined &&
                                                                        <form style={{ marginLeft: '12%' }}>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">1. Account #:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{'N/A'}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">2. User #:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{'N/A'}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">3. Provider Name:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.firstName + ' ' + provider.lastName}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">4. Provider Date of Birth:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{formatDateFromServer(provider.dob)}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">5. Provider Home Address:</label>
                                                                                <div className="col-auto col-sm-4">
                                                                                    <span>{formatAddress(provider.homeAddressLine1, provider.homeCity, null, provider.homeState, provider.homeZipCode)} </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">6. Provider Personal Phone Number:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.homePhone}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">7. Provider SSN:</label>
                                                                                <div className="col-auto col-sm-2 d-flex">
                                                                                    <span>{provider.ssn !== '' ? formatAndMaskSSN(provider.ssn, hideSSN) : ''}</span>
                                                                                    <span
                                                                                        data-toggle="tooltip"
                                                                                        data-placement="right"
                                                                                        title={hideSSN ? 'Show SSN' : 'Hide SSN'}
                                                                                        style={{
                                                                                            marginTop: '3px',
                                                                                            marginLeft: '10px',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    >
                                                                                        <i className={hideSSN ? 'fa fa-eye' : 'fa fa-eye-slash'} onClick={this.showHideSSN} />
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">8. Provider Email:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.email}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">9. Provider Specialty:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.specialty}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">10. Clinic Name:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.clinicName}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">11. Clinic Addresses:</label>
                                                                                <div className="col-auto">
                                                                                    {
                                                                                        provider.clinics != undefined && Object.keys(provider.clinics).length !== 0 ?
                                                                                            Object.keys(provider.clinics).map((addressId, index) => {
                                                                                                let clinicAddress = provider.clinics[addressId as any];
                                                                                                return (
                                                                                                    <div className="form-group row" key={index}>
                                                                                                        <label className="col-auto col-form-label">Address {index + 1}</label>
                                                                                                        <span>{formatAddress(clinicAddress.addressLine1, clinicAddress.city, null, clinicAddress.state, clinicAddress.zipCode)} </span>

                                                                                                        <label className="col-auto col-form-label">Phone</label>
                                                                                                        <span>{clinicAddress.phone} </span>

                                                                                                        <label className="col-auto col-form-label">Fax</label>
                                                                                                        <span>{clinicAddress.fax} </span>
                                                                                                    </div>
                                                                                                );
                                                                                            })
                                                                                            : ''
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">12. Provider State License #:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.stateLicense}</span>
                                                                                </div>
                                                                                <label className="col-auto col-form-label">Issuing State:</label>
                                                                                <span>{provider.issuingState && this.upperCaseFirst(USStates.find(state => state.code === provider.issuingState)?.name)}</span>
                                                                                <label className="col-auto col-form-label">Exp. Date:</label>
                                                                                <span>{formatDateFromServer(provider.expDate)}</span>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">13. Provider DEA #:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.dea}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">14. Provider Degree:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.degree}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">15. Provider NPI:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.npi}</span>
                                                                                </div>
                                                                            </div>
                                                                            {/* <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">16. Provider Tax ID:</label>
                                                                                <div className="col-auto col-sm-2">
                                                                                    <span>{provider.taxId}</span>
                                                                                </div>
                                                                            </div> */}
                                                                        </form>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="main-btn-group d-flex align-items-center">
                                    <button className="btn btn-sm btn-light" type="submit" onClick={this.submitToVendor} disabled={provider == undefined || provider.firstName === '' || loading || submitting}><i className="fa fa-send" /> Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PopupConfirm
                    showPopup={showPopup}
                    title={`Registration confirm`}
                    shouldHideNoButton={true}
                    loading={false}
                    onCancel={() => { }}
                    executeFunction={this.confirm}
                />
            </main>
        );
    }
}

export default Summary;


// WEBPACK FOOTER //
// ./src/components/Summary/Summary.tsx